module.exports = __webpack_public_path__ + "img/guge.750f3345.png";